<template>
    <div id="app" @scroll="scollHeader()">
        <!-- <img src="./assets/logo.png"> -->
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive"/>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"/>
    </div>
</template>

<script>
    export default {
        name: 'App',
        methods: {
            scollHeader() {
                console.log(`1`)
            }
        },
        mounted() {
            let that = this
            document.oncontextmenu = function () {
                if (that.$route.name == 'maggzine_detail') {
                    // alert('clickRight')
                    // return false;
                } else {
                    return false;
                }
            }
        }
    }
</script>

<style>
    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        /*text-align: center;*/
        color: #2c3e50;
        /*margin-top: 60px;*/
    }

    .el-image {
        display: flex !important;
        justify-content: center;
        align-items: center;
    }

    .goods_list .goodsInfo {
        position: absolute;
        top: 72%;
        text-align: center;
        width: 100%;
        background: rgba(255, 255, 255, .8);
        padding: .8rem 0;
    }

    .quanping_model .xijie {
        color: #f10075
    }
</style>



// WEBPACK FOOTER //
// src/App.vue